import { Component } from '@angular/core';

@Component({
  templateUrl: 'addrepoagent3.component.html'
})
export class Addrepoagent3Component {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/agencies/addrepoagent3.component.ts